import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-roster-members-panel',
  templateUrl: './roster-members-panel.component.html',
  styleUrls: ['./roster-members-panel.component.scss'],
  host: {
    'class': 'roster-left-panel',
    '[class.roster-left-panel--collapsed]': "gridHirView == 'full'"
  }
})
export class RosterMembersPanelComponent {

  @Input() rosterName: string;
  @Input() totalMembers: number;
  @Input() teamsData: any;
  @Input() filterData: any = '';
  @Input() filterRoster: any;
  @Input() searchby: string = 'search';
  @Input() selectAll: boolean = false;
  @Input() loading: any;
  @Input() rosterSearch: boolean = false;
  @Input() sortType: string = 'desc';
  @Input() queryType: string = 'first_name_order';
  @Input() currentPg: number = 1;
  @Input() roasterdefaultCounter: number = 20;
  @Input() defaultShowingMembers: number = 5;
  @Input() isDemoRoster: boolean = false;
  @Input() gridHirView: string = 'grid';

  @Output() rosterAddMember = new EventEmitter<void>();
  @Output() accordToggle = new EventEmitter<{ className: string; event: MouseEvent }>();
  @Output() searchRoaster = new EventEmitter<{ value: string; showHide: boolean; clear?: boolean }>();
  @Output() filterRosterChange = new EventEmitter<string>();
  @Output() updateFilter = new EventEmitter<any>();
  @Output() additionalTeamPopup = new EventEmitter<{ memberDetails: any; invitePop: boolean }>();
  @Output() selectAllChange = new EventEmitter<boolean>();
  @Output() selectAllRoaster = new EventEmitter<boolean>();
  @Output() sortRoaster = new EventEmitter<{ sortType: string; queryType: string }>();
  @Output() memberChecked = new EventEmitter<any>();
  @Output() editRosterMem = new EventEmitter<any>();
  @Output() removeRosterMem = new EventEmitter<{ record: any; oneOrMulti: number }>();
  @Output() roasterMembers = new EventEmitter<{ count: number; page: number }>();
  @Output() roasterdefaultCounterChange = new EventEmitter<number>();
  @Output() rosterMemberProfile = new EventEmitter<any>();
}
